import { overlays } from "../components/OverlayModuleList";
import useModules from "../hooks/useModules";

export default function Home() {
    const slug = "home";
    const { page, modules, loading, error } = useModules(slug);

    if (loading) {
        return (
            <div className="flex justify-center py-20">
                <div className="animate-spin w-10 h-10 border-4 border-gray-300 border-t-transparent rounded-full"></div>
            </div>
        );
    }

    if (error) {
        return (
            <p className="text-center py-20 text-red-600">
                Erreur : {error.message}
            </p>
        );
    }

    if (!page) {
        return <p className="text-center py-20 text-red-600">Page introuvable</p>;
    }

    return (
        <div>
            {modules.map((module) => {
                const OverlayComponent =
                    overlays[module.overlay_name] || overlays.DEFAULT;

                return <OverlayComponent key={module.id} module={module} />;
            })}
        </div>
    );
}
